import firebase from "@firebase/app";
import "@firebase/firestore";
import "@firebase/auth";
import "@firebase/storage";

const config = {
  apiKey: "AIzaSyA2KM6kCM-TPCHkhRzZRYUlYkiwN9EhUEo",
  authDomain: "testing-1941f.firebaseapp.com",
  databaseURL: "https://testing-1941f.firebaseio.com",
  projectId: "testing-1941f",
  storageBucket: "testing-1941f.appspot.com",
  messagingSenderId: "935583968559"
};

const app = firebase.initializeApp(config);
const db = firebase.firestore(app);
const auth = firebase.auth();
const storr = firebase.storage();
// const settings = {/* your settings... */ timestampsInSnapshots: true };
// db.settings(settings);



export {
  auth,
  db,
  storr,
  app
};




// WEBPACK FOOTER //
// ./src/firebase/firebase.js